<template>
    <div>
        <nav class="navbar navbar-expand-lg navbar-light">
            <div class="ml-auto">
                <form class="form-inline my-2 my-lg-0" v-on:keypress.enter.prevent="searchData(1)">
                    <b-form-select v-model="search.bank_id" :options="optionBankType">
                    </b-form-select> &nbsp;
                    <input class="form-control" v-model="search.code"
                           placeholder="ค้นหารหัสสาขา"/>
                    &nbsp;
                    <button type="button" class="btn btn-success" @click="searchData(1)">
                        <icon name="search"></icon>
                        ค้นหา
                    </button>&nbsp;
                    <button type="button" class="btn btn-warning" @click="showBranchDataModal">
                        <icon name="plus"></icon>
                        เพิ่มสาขาธนาคาร
                    </button>
                </form>
            </div>
        </nav>
        <div class="table-responsive">
            <table class="table table-bordered" style="text-align: center">
                <thead>
                <tr>
                    <th scope="col">ลำดับ</th>
                    <th scope="col">ธนาคาร</th>
                    <th scope="col">เลขสาขาธนาคาร</th>
                    <th scope="col">ชื่อสาขาธนาคาร</th>
                    <th scope="col">แก้ไข / ลบ</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(data,index) in bank_branch_table">
                    <td>{{((dataPaginate.current_page-1)*10)+(index+1)}}</td>
                    <td>{{data.bank ? data.bank.bank_code : ''}} {{data.bank ? data.bank.name : ''}}</td>
                    <td>{{data.branch_code}}</td>
                    <td>{{data.name}}</td>
                    <td>
                        <a @click="showData(data.id)">
                            <icon name="pencil-alt"></icon>
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
        <vue-pagination :pagination="dataPaginate"
                        @paginate="getBranchBank(dataPaginate.current_page)">
        </vue-pagination>
        <b-modal ref="branch_data" hide-footer hide-header>
            <bank-branch-modal :form="form" @submit="saveData">
            </bank-branch-modal>
        </b-modal>
    </div>
</template>

<script>
    import BankBranchModal from "./BankBranchModal";
    import VuePagination from "../../Pagination";
    import {mapState} from "vuex";
    export default {
        name: "BankBranchTable",
        components: {VuePagination, BankBranchModal},
        created() {
            this.$store.dispatch("Common/getBankType");
            this.getBranchBank(1);
        },
        computed:{
            ...mapState({
                optionBankType:state=>{
                    return [
                        {
                            value: "",
                            text: "เลือกธนาคาร"
                        },
                        ...state.Common.bank_type.map(type => ({
                            value: type.id,
                            text: type.name
                        }))
                    ];
                },
            })
        },
        data(){
            return{
                bank_branch_table : [],
                dataPaginate : {
                    current_page: 1,
                    from: 1,
                    last_page: 1,
                    per_page: 1,
                    total: 1,
                    to: 1
                },
                form : {
                    id : '',
                    bank_id : '',
                    branch_code : '',
                    name : '',
                },
                search:{
                    code : '',
                    bank_id : ''
                }
            }
        },
        methods:{
            getBranchBank(page){
                this.$store.dispatch("Bank/getBranchBank",page).then(res=>{
                    this.bank_branch_table = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.from,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    };
                });
            },
            showBranchDataModal(){
                this.$refs.branch_data.show();
            },
            hideBranchDataModal(){
                this.$refs.branch_data.hide();
            },
            saveData(value){
                if(value){
                    this.$store.dispatch("Bank/saveBranchBank",{
                        id : value.id,
                        data : value
                    }).then(()=>{
                        this.getBranchBank(this.dataPaginate.current_page);
                    })
                }
                this.clearData();
                this.hideBranchDataModal();
            },
            showData(id){
                this.$store.dispatch("Bank/showBranchBank",id).then(res=>{
                    this.form = res;
                    this.showBranchDataModal();
                }).catch(()=>{
                    alert('ไม่แก้ไขข้อมูลได้');
                })
            },
            searchData(page){
                this.$store.dispatch("Bank/searchBranchBank", {
                    page : page,
                    data : this.search
                }).then(res=>{
                    this.bank_branch_table = res.data;
                    this.dataPaginate = {
                        current_page: res.current_page,
                        from: res.from,
                        last_page: res.last_page,
                        per_page: res.per_page,
                        total: res.total,
                        to: res.to
                    };
                });
            },
            clearData(){
                this.form = {
                    id : '',
                    bank_id : '',
                    branch_code : '',
                    name : '',
                }
            }
        }
    }
</script>

<style scoped>

</style>
